import { CarSideIcon } from './CarSideIcon';

/**
 * author: GreenTurtwig
 * id CB49A868-3317-4445-BFED-13CB6533000E
 * name car-side
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-side.svg
 * tags
 * - Transportation + Road 
 * - Automotive 
 */
export const CarSaloonIcon = CarSideIcon;
export default CarSaloonIcon